import type { AbstractControl, ValidationErrors } from '@angular/forms';

/**
 * YouTube URL helpers. Ports the regex used by the legacy Symfony app
 * (MediaExtension / ValidYoutubeUrlValidator) so behaviour matches.
 */
const YOUTUBE_ID_RE = /^.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/)|(?:(?:watch)?\?v(?:i)?=|&v(?:i)?=))([^#&?]*).*/i;

/** Extracts the 11-ish char video id from any YouTube URL, or null if it isn't one. */
export function extractYoutubeId(url: string | null | undefined): string | null {
  if (!url) {
    return null;
  }
  const match = YOUTUBE_ID_RE.exec(url);
  return match?.[1] ? match[1] : null;
}

/** Thumbnail image URL for a video id (matches Symfony's MediaExtension). */
export function youtubeThumbnailUrl(id: string): string {
  return `https://img.youtube.com/vi/${id}/hqdefault.jpg`;
}

/** Embed URL for an <iframe>, optionally autoplaying. */
export function youtubeEmbedUrl(id: string, autoplay = false): string {
  return `https://www.youtube.com/embed/${id}${autoplay ? '?autoplay=1' : ''}`;
}

/** Form validator: valid when empty or a recognisable YouTube URL. Mirrors Symfony's ValidYoutubeUrl. */
export function youtubeUrlValidator(control: AbstractControl): ValidationErrors | null {
  const value = control.value as string | null;
  if (!value) {
    return null;
  }
  return extractYoutubeId(value) ? null : { youtube: true };
}
